// BEGIN motorbikeBackpackGalleryRestore20260716
;(function motorbikeBackpackGalleryRestore20260716() {
  var config = {
  "handle": "seibertron-sps-7-superior-protection-series-motorcycle-riding-gloves",
  "entries": [
    {
      "id": "33237161771198",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/b2b8ea825506ca2c.jpg?v=1782287564",
      "alt": "Seibertron SPS-7 motorcycle gloves in White"
    },
    {
      "id": "33237161803966",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/ebcb8004ba351b5f.jpg?v=1782287564",
      "alt": "Seibertron SPS-7 motorcycle gloves in Black"
    },
    {
      "id": "33237161836734",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/847b731dc8349fc9.jpg?v=1782287565",
      "alt": "Seibertron SPS-7 motorcycle gloves in Fluorescent Orange"
    },
    {
      "id": "33237161869502",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/5b3e52f7af538cb2.jpg?v=1782287564",
      "alt": "Seibertron SPS-7 motorcycle gloves in Red"
    },
    {
      "id": "33237161902270",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/1c554c1f8520c1f5.jpg?v=1782287564",
      "alt": "Seibertron SPS-7 motorcycle gloves in Pink"
    },
    {
      "id": "33237161935038",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/eaeac84ba3013bf0.jpg?v=1782287564",
      "alt": "Seibertron SPS-7 motorcycle gloves in Gold"
    },
    {
      "id": "33237161967806",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/353f9b9df187ad55.jpg?v=1782287564",
      "alt": "Seibertron SPS-7 motorcycle gloves in Klein Blue"
    },
    {
      "id": "33237162000574",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/5651139477bca491.jpg?v=1782287565",
      "alt": "Seibertron SPS-7 motorcycle gloves in Green"
    },
    {
      "id": "33237162033342",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/5ee73912a6fb2054.jpg?v=1782287564",
      "alt": "Seibertron SPS-7 motorcycle gloves in Brown"
    },
    {
      "id": "33237162066110",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/4bed9e65f861d144.jpg?v=1782287564",
      "alt": "Seibertron SPS-7 motorcycle gloves in Fluorescent Yellow"
    }
  ],
  "variants": [
    {
      "id": "47706381910206",
      "title": "White / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "White",
        "Youth L"
      ],
      "mediaId": "33237161771198"
    },
    {
      "id": "47706381942974",
      "title": "White / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "White",
        "Youth XL"
      ],
      "mediaId": "33237161771198"
    },
    {
      "id": "47706381975742",
      "title": "White / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "White",
        "Adult S"
      ],
      "mediaId": "33237161771198"
    },
    {
      "id": "47706382008510",
      "title": "White / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "White",
        "Adult M"
      ],
      "mediaId": "33237161771198"
    },
    {
      "id": "47706382041278",
      "title": "White / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "White",
        "Adult L"
      ],
      "mediaId": "33237161771198"
    },
    {
      "id": "47706382074046",
      "title": "White / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "White",
        "Adult XL"
      ],
      "mediaId": "33237161771198"
    },
    {
      "id": "47706382106814",
      "title": "White / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "White",
        "Adult XXL"
      ],
      "mediaId": "33237161771198"
    },
    {
      "id": "47706382139582",
      "title": "White / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "White",
        "Adult XXXL"
      ],
      "mediaId": "33237161771198"
    },
    {
      "id": "47706382172350",
      "title": "Black / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Black",
        "Youth L"
      ],
      "mediaId": "33237161803966"
    },
    {
      "id": "47706382205118",
      "title": "Black / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Black",
        "Youth XL"
      ],
      "mediaId": "33237161803966"
    },
    {
      "id": "47706382237886",
      "title": "Black / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Black",
        "Adult S"
      ],
      "mediaId": "33237161803966"
    },
    {
      "id": "47706382270654",
      "title": "Black / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Black",
        "Adult M"
      ],
      "mediaId": "33237161803966"
    },
    {
      "id": "47706382303422",
      "title": "Black / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Black",
        "Adult L"
      ],
      "mediaId": "33237161803966"
    },
    {
      "id": "47706382336190",
      "title": "Black / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Black",
        "Adult XL"
      ],
      "mediaId": "33237161803966"
    },
    {
      "id": "47706382368958",
      "title": "Black / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Black",
        "Adult XXL"
      ],
      "mediaId": "33237161803966"
    },
    {
      "id": "47706382401726",
      "title": "Black / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "Black",
        "Adult XXXL"
      ],
      "mediaId": "33237161803966"
    },
    {
      "id": "47706382434494",
      "title": "Fluorescent Orange / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Orange"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Fluorescent Orange",
        "Youth L"
      ],
      "mediaId": "33237161836734"
    },
    {
      "id": "47706382467262",
      "title": "Fluorescent Orange / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Orange"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Fluorescent Orange",
        "Youth XL"
      ],
      "mediaId": "33237161836734"
    },
    {
      "id": "47706382500030",
      "title": "Fluorescent Orange / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Orange"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Fluorescent Orange",
        "Adult S"
      ],
      "mediaId": "33237161836734"
    },
    {
      "id": "47706382532798",
      "title": "Fluorescent Orange / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Orange"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Fluorescent Orange",
        "Adult M"
      ],
      "mediaId": "33237161836734"
    },
    {
      "id": "47706382565566",
      "title": "Fluorescent Orange / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Orange"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Fluorescent Orange",
        "Adult L"
      ],
      "mediaId": "33237161836734"
    },
    {
      "id": "47706382598334",
      "title": "Fluorescent Orange / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Orange"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Fluorescent Orange",
        "Adult XL"
      ],
      "mediaId": "33237161836734"
    },
    {
      "id": "47706382631102",
      "title": "Fluorescent Orange / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Orange"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Fluorescent Orange",
        "Adult XXL"
      ],
      "mediaId": "33237161836734"
    },
    {
      "id": "47706382663870",
      "title": "Fluorescent Orange / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Orange"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "Fluorescent Orange",
        "Adult XXXL"
      ],
      "mediaId": "33237161836734"
    },
    {
      "id": "47706382696638",
      "title": "Red / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Red",
        "Youth L"
      ],
      "mediaId": "33237161869502"
    },
    {
      "id": "47706382729406",
      "title": "Red / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Red",
        "Youth XL"
      ],
      "mediaId": "33237161869502"
    },
    {
      "id": "47706382762174",
      "title": "Red / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Red",
        "Adult S"
      ],
      "mediaId": "33237161869502"
    },
    {
      "id": "47706382794942",
      "title": "Red / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Red",
        "Adult M"
      ],
      "mediaId": "33237161869502"
    },
    {
      "id": "47706382827710",
      "title": "Red / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Red",
        "Adult L"
      ],
      "mediaId": "33237161869502"
    },
    {
      "id": "47706382860478",
      "title": "Red / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Red",
        "Adult XL"
      ],
      "mediaId": "33237161869502"
    },
    {
      "id": "47706382893246",
      "title": "Red / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Red",
        "Adult XXL"
      ],
      "mediaId": "33237161869502"
    },
    {
      "id": "47706382926014",
      "title": "Red / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "Red",
        "Adult XXXL"
      ],
      "mediaId": "33237161869502"
    },
    {
      "id": "47706382958782",
      "title": "Pink / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Pink",
        "Youth L"
      ],
      "mediaId": "33237161902270"
    },
    {
      "id": "47706382991550",
      "title": "Pink / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Pink",
        "Youth XL"
      ],
      "mediaId": "33237161902270"
    },
    {
      "id": "47706383024318",
      "title": "Pink / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Pink",
        "Adult S"
      ],
      "mediaId": "33237161902270"
    },
    {
      "id": "47706383057086",
      "title": "Pink / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Pink",
        "Adult M"
      ],
      "mediaId": "33237161902270"
    },
    {
      "id": "47706383089854",
      "title": "Pink / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Pink",
        "Adult L"
      ],
      "mediaId": "33237161902270"
    },
    {
      "id": "47706383122622",
      "title": "Pink / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Pink",
        "Adult XL"
      ],
      "mediaId": "33237161902270"
    },
    {
      "id": "47706383155390",
      "title": "Pink / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Pink",
        "Adult XXL"
      ],
      "mediaId": "33237161902270"
    },
    {
      "id": "47706383188158",
      "title": "Pink / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Pink"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "Pink",
        "Adult XXXL"
      ],
      "mediaId": "33237161902270"
    },
    {
      "id": "47706383220926",
      "title": "Gold / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Gold"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Gold",
        "Youth L"
      ],
      "mediaId": "33237161935038"
    },
    {
      "id": "47706383253694",
      "title": "Gold / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Gold"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Gold",
        "Youth XL"
      ],
      "mediaId": "33237161935038"
    },
    {
      "id": "47706383286462",
      "title": "Gold / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Gold"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Gold",
        "Adult S"
      ],
      "mediaId": "33237161935038"
    },
    {
      "id": "47706383319230",
      "title": "Gold / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Gold"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Gold",
        "Adult M"
      ],
      "mediaId": "33237161935038"
    },
    {
      "id": "47706383351998",
      "title": "Gold / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Gold"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Gold",
        "Adult L"
      ],
      "mediaId": "33237161935038"
    },
    {
      "id": "47706383384766",
      "title": "Gold / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Gold"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Gold",
        "Adult XL"
      ],
      "mediaId": "33237161935038"
    },
    {
      "id": "47706383417534",
      "title": "Gold / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Gold"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Gold",
        "Adult XXL"
      ],
      "mediaId": "33237161935038"
    },
    {
      "id": "47706383450302",
      "title": "Gold / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Gold"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "Gold",
        "Adult XXXL"
      ],
      "mediaId": "33237161935038"
    },
    {
      "id": "47706383483070",
      "title": "Klein Blue / Youth L",
      "availableForSale": false,
      "options": [
        {
          "name": "Color",
          "value": "Klein Blue"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Klein Blue",
        "Youth L"
      ],
      "mediaId": "33237161967806"
    },
    {
      "id": "47706383515838",
      "title": "Klein Blue / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Klein Blue"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Klein Blue",
        "Youth XL"
      ],
      "mediaId": "33237161967806"
    },
    {
      "id": "47706383548606",
      "title": "Klein Blue / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Klein Blue"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Klein Blue",
        "Adult S"
      ],
      "mediaId": "33237161967806"
    },
    {
      "id": "47706383581374",
      "title": "Klein Blue / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Klein Blue"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Klein Blue",
        "Adult M"
      ],
      "mediaId": "33237161967806"
    },
    {
      "id": "47706383614142",
      "title": "Klein Blue / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Klein Blue"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Klein Blue",
        "Adult L"
      ],
      "mediaId": "33237161967806"
    },
    {
      "id": "47706383646910",
      "title": "Klein Blue / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Klein Blue"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Klein Blue",
        "Adult XL"
      ],
      "mediaId": "33237161967806"
    },
    {
      "id": "47706383679678",
      "title": "Klein Blue / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Klein Blue"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Klein Blue",
        "Adult XXL"
      ],
      "mediaId": "33237161967806"
    },
    {
      "id": "47706383712446",
      "title": "Klein Blue / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Klein Blue"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "Klein Blue",
        "Adult XXXL"
      ],
      "mediaId": "33237161967806"
    },
    {
      "id": "47706383745214",
      "title": "Green / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Green"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Green",
        "Youth L"
      ],
      "mediaId": "33237162000574"
    },
    {
      "id": "47706383777982",
      "title": "Green / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Green"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Green",
        "Youth XL"
      ],
      "mediaId": "33237162000574"
    },
    {
      "id": "47706383810750",
      "title": "Green / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Green"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Green",
        "Adult S"
      ],
      "mediaId": "33237162000574"
    },
    {
      "id": "47706383843518",
      "title": "Green / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Green"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Green",
        "Adult M"
      ],
      "mediaId": "33237162000574"
    },
    {
      "id": "47706383876286",
      "title": "Green / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Green"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Green",
        "Adult L"
      ],
      "mediaId": "33237162000574"
    },
    {
      "id": "47706383909054",
      "title": "Green / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Green"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Green",
        "Adult XL"
      ],
      "mediaId": "33237162000574"
    },
    {
      "id": "47706383941822",
      "title": "Green / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Green"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Green",
        "Adult XXL"
      ],
      "mediaId": "33237162000574"
    },
    {
      "id": "47706383974590",
      "title": "Green / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Green"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "Green",
        "Adult XXXL"
      ],
      "mediaId": "33237162000574"
    },
    {
      "id": "47706384007358",
      "title": "Brown / Youth L",
      "availableForSale": false,
      "options": [
        {
          "name": "Color",
          "value": "Brown"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Brown",
        "Youth L"
      ],
      "mediaId": "33237162033342"
    },
    {
      "id": "47706384040126",
      "title": "Brown / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Brown"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Brown",
        "Youth XL"
      ],
      "mediaId": "33237162033342"
    },
    {
      "id": "47706384072894",
      "title": "Brown / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Brown"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Brown",
        "Adult S"
      ],
      "mediaId": "33237162033342"
    },
    {
      "id": "47706384105662",
      "title": "Brown / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Brown"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Brown",
        "Adult M"
      ],
      "mediaId": "33237162033342"
    },
    {
      "id": "47706384138430",
      "title": "Brown / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Brown"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Brown",
        "Adult L"
      ],
      "mediaId": "33237162033342"
    },
    {
      "id": "47706384171198",
      "title": "Brown / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Brown"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Brown",
        "Adult XL"
      ],
      "mediaId": "33237162033342"
    },
    {
      "id": "47706384203966",
      "title": "Brown / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Brown"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Brown",
        "Adult XXL"
      ],
      "mediaId": "33237162033342"
    },
    {
      "id": "47706384236734",
      "title": "Brown / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Brown"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "Brown",
        "Adult XXXL"
      ],
      "mediaId": "33237162033342"
    },
    {
      "id": "47706384269502",
      "title": "Fluorescent Yellow / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Yellow"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Fluorescent Yellow",
        "Youth L"
      ],
      "mediaId": "33237162066110"
    },
    {
      "id": "47706384302270",
      "title": "Fluorescent Yellow / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Yellow"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Fluorescent Yellow",
        "Youth XL"
      ],
      "mediaId": "33237162066110"
    },
    {
      "id": "47706384335038",
      "title": "Fluorescent Yellow / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Yellow"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Fluorescent Yellow",
        "Adult S"
      ],
      "mediaId": "33237162066110"
    },
    {
      "id": "47706384367806",
      "title": "Fluorescent Yellow / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Yellow"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Fluorescent Yellow",
        "Adult M"
      ],
      "mediaId": "33237162066110"
    },
    {
      "id": "47706384400574",
      "title": "Fluorescent Yellow / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Yellow"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Fluorescent Yellow",
        "Adult L"
      ],
      "mediaId": "33237162066110"
    },
    {
      "id": "47706384433342",
      "title": "Fluorescent Yellow / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Yellow"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Fluorescent Yellow",
        "Adult XL"
      ],
      "mediaId": "33237162066110"
    },
    {
      "id": "47706384466110",
      "title": "Fluorescent Yellow / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Yellow"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Fluorescent Yellow",
        "Adult XXL"
      ],
      "mediaId": "33237162066110"
    },
    {
      "id": "47706384498878",
      "title": "Fluorescent Yellow / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Yellow"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "Fluorescent Yellow",
        "Adult XXXL"
      ],
      "mediaId": "33237162066110"
    }
  ],
  "singleVariant": false
};
  var applying = false;
  function root() {
    return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]');
  }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function selectedValues(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('input[name^="options["]:checked')).map(function (input) {
      return input.value || '';
    });
  }
  function selectedEntry(scope) {
    var values = selectedValues(scope);
    var variant = config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    });
    return variant ? config.entries.find(function (entry) { return entry.id === variant.mediaId; }) : null;
  }
  function selectedVariant(scope) {
    var values = selectedValues(scope);
    return config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    }) || null;
  }
  function syncPurchase(scope) {
    var variant = selectedVariant(scope);
    if (!variant) return;
    scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (field) {
      if (String(field.value || '') !== String(variant.id)) {
        field.value = variant.id;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    scope.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach(function (button) {
      button.disabled = !variant.availableForSale;
      button.setAttribute('aria-disabled', variant.availableForSale ? 'false' : 'true');
      var label = button.querySelector('span') || button;
      if (variant.availableForSale && /solds*out|unavailable/i.test(label.textContent || '')) label.textContent = 'Add to Cart';
      if (!variant.availableForSale && /adds*tos*cart/i.test(label.textContent || '')) label.textContent = 'Sold Out';
    });
  }
  function setMain(scope, entry) {
    var main = scope.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function syncVisualChoices(scope) {
    scope.querySelectorAll('.auto-product__choice--visual').forEach(function (choice) {
      var input = choice.querySelector('input[name^="options["]');
      if (!input) return;
      var optionMatch = String(input.name || '').match(/^options\[(.+)\]$/);
      if (!optionMatch) return;
      var optionName = optionMatch[1];
      var mediaIds = config.variants.filter(function (variant) {
        return (variant.options || []).some(function (option) {
          return option.name === optionName && option.value === input.value;
        });
      }).map(function (variant) { return variant.mediaId; }).filter(Boolean).filter(function (id, index, all) {
        return all.indexOf(id) === index;
      });
      if (mediaIds.length !== 1) return;
      var entry = config.entries.find(function (item) { return item.id === mediaIds[0]; });
      if (!entry) return;
      var swatch = choice.querySelector('.auto-product__swatch-image');
      if (!swatch) {
        swatch = document.createElement('span');
        swatch.className = 'auto-product__swatch-image';
        swatch.setAttribute('aria-label', input.value || entry.alt || '');
        (choice.querySelector('[data-auto-choice-label]') || choice).appendChild(swatch);
      }
      var image = swatch.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        image.width = 72;
        image.height = 72;
        image.loading = 'lazy';
        swatch.appendChild(image);
      }
      image.src = sized(entry.src, 180);
      image.srcset = '';
      image.alt = input.value || entry.alt || '';
      choice.setAttribute('data-variant-media-id', entry.id);
    });
  }
  function syncSingleVariantLegend(scope) {
    if (!config.singleVariant) return;
    scope.querySelectorAll('.auto-product__option legend').forEach(function (legend) {
      legend.style.setProperty('justify-content', 'flex-start', 'important');
      legend.style.setProperty('align-items', 'center', 'important');
      legend.style.setProperty('gap', '16px', 'important');
      legend.style.setProperty('width', 'fit-content', 'important');
      legend.style.setProperty('max-width', '100%', 'important');
    });
  }
  function ensureThumb(scope, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.setAttribute('aria-hidden', 'false');
    thumb.hidden = false;
    thumb.style.display = '';
    if (!thumb.querySelector('img')) {
      thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="lazy">';
    }
    if (thumb.dataset.motorbikeGalleryBound !== 'true') {
      thumb.dataset.motorbikeGalleryBound = 'true';
      thumb.addEventListener('click', function () {
        setMain(scope, entry);
        scope.querySelectorAll('[data-auto-thumb]').forEach(function (node) {
          node.classList.toggle('is-active', node === thumb);
        });
      });
    }
    return thumb;
  }
  function hydrate() {
    if (applying) return;
    var scope = root();
    if (!scope) return;
    var wrap = scope.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    applying = true;
    var desiredSafeIds = '|' + config.entries.map(function (entry) { return entry.id; }).join('|') + '|';
    if (scope.getAttribute('data-safe-gallery-media-ids') !== desiredSafeIds) {
      scope.setAttribute('data-safe-gallery-media-ids', desiredSafeIds);
    }
    config.entries.forEach(function (entry, index) { ensureThumb(scope, wrap, entry, index); });
    scope.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.hidden = false;
      thumb.style.display = '';
      thumb.setAttribute('aria-hidden', 'false');
    });
    syncVisualChoices(scope);
    syncSingleVariantLegend(scope);
    syncPurchase(scope);
    setMain(scope, selectedEntry(scope));
    applying = false;
  }
  function run() {
    var scope = root();
    if (!scope) return;
    hydrate();
    if (scope.dataset.motorbikeBackpackGalleryRestoreBound === 'true') return;
    scope.dataset.motorbikeBackpackGalleryRestoreBound = 'true';
    scope.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('input[name^="options["]')) return;
      [0, 80, 250, 700, 1400].forEach(function (delay) {
        window.setTimeout(function () {
          hydrate();
          setMain(scope, selectedEntry(scope));
          syncPurchase(scope);
        }, delay);
      });
    });
    var observer = new MutationObserver(function (records) {
      if (applying) return;
      var changed = records.some(function (record) { return record.addedNodes.length || record.removedNodes.length; });
      if (changed) window.setTimeout(hydrate, 20);
    });
    observer.observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-safe-gallery-media-ids'] });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [150, 500, 1300, 3000, 6000, 10000].forEach(function (delay) { window.setTimeout(hydrate, delay); });
  window.setInterval(hydrate, 1200);
})();
// END motorbikeBackpackGalleryRestore20260716
